/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function e(e,t,l,n){let u=null,a=1e3;"number"==typeof t?(a=t,n=l):(u=null!=t?t:null,a=l);let o,p=0;const r=()=>{p=0,e.apply(n,o)},c=(...e)=>{u&&u.apply(n,e),o=e,a?p||(p=setTimeout(r,a)):r()};return c.remove=()=>{p&&(clearTimeout(p),p=0)},c.forceUpdate=()=>{p&&(clearTimeout(p),r())},c.hasPendingUpdates=()=>!!p,c}export{e as default,e as throttle};
